document.documentElement.classList.remove('no-js');

const fmt=(cents,c='USD')=>{
  try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:c}).format((cents||0)/100)}
  catch(e){return '$'+((cents||0)/100).toFixed(2)}
};

async function getCart(){
  return fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root+'cart.js' : '/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
}

async function renderCart(){
  const d=document.getElementById('CartDrawer');
  if(!d)return;
  const b=d.querySelector('[data-cart-body]');
  const c=await getCart();
  document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=c.item_count);

  if(!c.items.length){
    b.innerHTML='<p>Your cart is empty.</p>';
    return;
  }

  b.innerHTML=c.items.map(i=>`
    <div class="cartitem">
      ${i.image?`<img src="${i.image}" alt="">`:''}
      <div>
        <strong>${i.product_title}</strong>
        ${i.variant_title&&i.variant_title!=='Default Title'?`<div class="muted">${i.variant_title}</div>`:''}
        <div>${i.quantity} × ${fmt(i.final_price,c.currency)}</div>
      </div>
      <button class="iconbtn" data-remove="${i.key}" aria-label="Remove item">×</button>
    </div>
  `).join('')+`
    <div class="carttotal"><span>TOTAL</span><span>${fmt(c.total_price,c.currency)}</span></div>
    <a class="btn btn--primary" style="width:100%" href="/checkout">CHECKOUT</a>
    <p class="muted" style="font-size:12px;text-align:center">Secure checkout with PayPal</p>
  `;

  b.querySelectorAll('[data-remove]').forEach(x=>{
    x.onclick=async()=>{
      await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root+'cart/change.js' : '/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:x.dataset.remove,quantity:0})
      });
      renderCart();
    };
  });
}

function openCart(){
  const d=document.getElementById('CartDrawer');
  if(!d)return;
  d.setAttribute('aria-hidden','false');
  document.body.style.overflow='hidden';
  renderCart();
}

function closeCart(){
  const d=document.getElementById('CartDrawer');
  if(!d)return;
  d.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
}

function toggleMenu(force){
  const menu=document.getElementById('MobileMenu');
  const btn=document.querySelector('[data-menu-toggle]');
  if(!menu||!btn)return;
  const open=typeof force==='boolean'?force:menu.getAttribute('aria-hidden')==='true';
  menu.setAttribute('aria-hidden',open?'false':'true');
  btn.setAttribute('aria-expanded',open?'true':'false');
}

document.addEventListener('click',e=>{
  if(e.target.closest('[data-cart-open]')){e.preventDefault();openCart()}
  if(e.target.closest('[data-cart-close]')){e.preventDefault();closeCart()}
  if(e.target.closest('[data-menu-toggle]')){e.preventDefault();toggleMenu()}
  if(e.target.closest('[data-menu-link]')){toggleMenu(false)}
  if(e.target.closest('[data-scroll-buy]')){
    e.preventDefault();
    document.querySelector('[data-product-scope]')?.scrollIntoView({behavior:'smooth',block:'start'});
  }
});

document.addEventListener('keydown',e=>{
  if(e.key==='Escape'){closeCart();toggleMenu(false)}
});

document.addEventListener('submit',async e=>{
  const f=e.target.closest('[data-product-form]');
  if(!f)return;
  e.preventDefault();

  const b=f.querySelector('[type=submit]');
  const t=b?.textContent;
  if(b){b.disabled=true;b.textContent='ADDING…'}

  try{
    const r=await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root+'cart/add.js' : '/cart/add.js',{
      method:'POST',
      headers:{Accept:'application/json'},
      body:new FormData(f)
    });
    if(!r.ok)throw 0;
    openCart();

    if(window.dataLayer){
      window.dataLayer.push({event:'sequor_add_to_cart'});
    }
  }catch(x){
    alert('Unable to add this item right now. Please try again.');
  }finally{
    if(b){b.disabled=false;b.textContent=t}
  }
});

document.addEventListener('change',e=>{
  const i=e.target.closest('[data-variant]');
  if(!i)return;

  const s=i.closest('[data-product-scope]');
  if(!s)return;

  s.querySelectorAll('.variant').forEach(v=>v.classList.remove('is-selected'));
  i.closest('.variant')?.classList.add('is-selected');

  s.querySelectorAll('[data-variant-id]').forEach(x=>x.value=i.value);
  s.querySelectorAll('[data-sticky-variant-id]').forEach(x=>x.value=i.value);
  s.querySelectorAll('[data-current-price]').forEach(x=>x.textContent=i.dataset.price);
  s.querySelectorAll('[data-sticky-price]').forEach(x=>x.textContent=i.dataset.price);

  const compare=s.querySelector('[data-compare-price]');
  if(compare){
    compare.textContent=i.dataset.compare||'';
    compare.hidden=!i.dataset.compare;
  }

  if(window.dataLayer){
    window.dataLayer.push({event:'sequor_variant_selected',variant_id:i.value});
  }
});


// V11 product commerce interactions
function sequorActivateMedia(scope, mediaId){
  if(!scope || !mediaId) return;
  scope.querySelectorAll('[data-media-slide]').forEach(x=>x.classList.toggle('is-active', String(x.dataset.mediaSlide)===String(mediaId)));
  scope.querySelectorAll('[data-media-thumb]').forEach(x=>x.classList.toggle('is-active', String(x.dataset.mediaThumb)===String(mediaId)));
}
function sequorSelectVariant(scope, variantId, scroll=false){
  if(!scope) return;
  const choice=scope.querySelector(`[data-commerce-variant][data-variant-id="${variantId}"]`);
  if(!choice) return;
  scope.querySelectorAll('[data-commerce-variant]').forEach(x=>{x.classList.remove('is-selected');x.setAttribute('aria-pressed','false')});
  choice.classList.add('is-selected');choice.setAttribute('aria-pressed','true');
  scope.querySelectorAll('[data-commerce-variant-input], [data-commerce-express-input]').forEach(x=>x.value=variantId);
  scope.querySelectorAll('[data-commerce-price], [data-commerce-sticky-price]').forEach(x=>x.textContent=choice.dataset.price||'');
  const compare=scope.querySelector('[data-commerce-compare]');
  if(compare){compare.textContent=choice.dataset.compare||'';compare.hidden=!choice.dataset.compare}
  const add=scope.querySelector('[data-commerce-add-button]');
  const available=choice.dataset.available==='true';
  if(add){add.disabled=!available;add.textContent=available?'ADD TO CART':'SOLD OUT'}
  if(choice.dataset.mediaId) sequorActivateMedia(scope,choice.dataset.mediaId);
  try{const u=new URL(window.location.href);u.searchParams.set('variant',variantId);history.replaceState({},'',u)}catch(e){}
  if(scroll) scope.scrollIntoView({behavior:'smooth',block:'start'});
  if(window.dataLayer)window.dataLayer.push({event:'sequor_variant_selected',variant_id:variantId});
}
document.addEventListener('click',e=>{
  const thumb=e.target.closest('[data-media-thumb]');
  if(thumb){sequorActivateMedia(thumb.closest('[data-commerce-section]'),thumb.dataset.mediaThumb);return}
  const choice=e.target.closest('[data-commerce-variant]');
  if(choice){sequorSelectVariant(choice.closest('[data-commerce-section]'),choice.dataset.variantId);return}
  const external=e.target.closest('[data-select-commerce-variant]');
  if(external){
    const scope=document.querySelector('[data-commerce-section]');
    sequorSelectVariant(scope,external.dataset.selectCommerceVariant,true);return;
  }
  const sticky=e.target.closest('[data-commerce-sticky-add]');
  if(sticky){
    const scope=sticky.closest('[data-commerce-section]');
    scope?.querySelector('[data-commerce-add-button]')?.click();
  }
});
